<template>
    <div class="shoool-search-component mt-[66px]">
        <div class="relative">
            <div class="school-search">
                <!-- Input Search -->
                <div class="school-box-bg" :class="{ mobileResults: showMobileResults || (orderedSchools && !mobileDevice), schoolSelected: isSchoolSelected }">
                    <div id="search-box" :class="{ autocompleted: orderedSchools, schoolSelected: isSchoolSelected }">
                        <div class="search-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <div class="search-input">
                            <input
                                type="text"
                                id="input-search"
                                v-model="inputValue"
                                :placeholder="placeholderText"
                                @keyup="autocompleteStreet"
                            />
                            <button
                                id="remove-input"
                                :class="{hidden: hideClearCross}"
                                @click="clearInput"
                            >
                                <img src="/img/icons/cancel.svg" alt="" />
                            </button>
                        </div>
                    </div>              
                </div>

                <!-- Results Location -->
                <div
                    id="result-box"
                    :class="[
                        gotResults && !orderedSchools ? 'block' : 'hidden',
                        isSchoolSelected ? 'schoolSelected' : ''
                    ]"
                >
                    <!-- If got results show box -->
                    <button
                        v-for="(prediction, key) in predictions"
                        :key="key"
                        @click="autocompleteInput(prediction.place_id)"
                        class="result"
                    >
                        <span class="street">{{
                            prediction.structured_formatting.main_text
                        }}</span>
                        <span class="city">{{
                            prediction.structured_formatting.secondary_text
                        }}</span>
                    </button>
                </div>

                <!-- Results Nearest Schools -->
                <SchoolBox
                    v-if="showResults"
                    :orderedSchools="orderedSchools"
                    :schools="schools"
                    @selectSchool="setSchoolFromList"
                />

                <SchoolInfoPopup
                    v-if="showPopup"
                    :school="selectedSchool"
                />

                <!-- Show Results Button -->
                <button
                    id="show-results"
                    :class="[
                        orderedSchools && mobileDevice ? 'flex' : 'hidden'
                    ]"
                    @click="showMobileResults = !showMobileResults"
                >
                    <img :src="'/img/icons/' + showButtonIcon + '.svg'" />
                    {{ showMobileText }}
                </button>
            </div>
            <div class="w-full">
                <!-- MAP -->
                <base-map
                    :items="schools"
                    center-map-on-click
                    @itemClicked="setSchool"
                    class="school-search-map"
                    :class="{ 'width-calculated': orderedSchools }"
                    ref="mapComponent"
                ></base-map>
            </div>
        </div>
    </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import SchoolBox from "./Map/SchoolBox.vue";
import SchoolInfoPopup from "./Map/SchoolInfoPopup.vue";
import GoogleMapApi from "../GoogleMapApi";
import {getCenterOfSchools, sortSchoolsByDistance} from '../SchoolHelper';

export default {
    components: {
        SchoolBox,
        SchoolInfoPopup
    },
    props: {
        schools: {
            type: Array,
            default: () => {
                return [];
            }
        },
        mapkey: {
            type: String
        },
        schoolselected: {
            type: String
        }
    },
    computed: {
        placeholderText() {
            if (isMobile) return this.trans.placeholderInputMobile;
            return this.trans.placeholderInputDesktop;
        },
        gotResults() {
            return this.predictions.length;
        },
        showResults() {
            return !isMobile || this.showMobileResults;
        },
        showMobileText() {
            return !this.showMobileResults ? this.trans?.viewList : this.trans?.viewMap;
        },
        showButtonIcon() {
            return !this.showMobileResults ? "list" : "map-folded-paper";
        },
        isSchoolSelected() {
            return this.schoolselected ? true : false;
        }
    },
    data() {
        return {
            mobileDevice: isMobile,
            showMobileResults: false,
            showPopup: false,
            orderedSchools: false,
            inputValue: '',
            toggleMode: {
                active: false,
                type: "map"
            },
            hideClearCross: true,
            predictions: [],
            selectedSchool: null,
            googleSearch: null,
            trans: ''
        };
    },
    created(){
        this.googleSearch = new GoogleMapApi(this.mapkey, "41.3825,2.176944")
    },
    methods: {
        setSchool(payload){
            this.selectedSchool = payload;
            this.showPopup = true;
        },
        setSchoolFromList({school, zoom}){
            this.$refs.mapComponent.setMapCenter({latitude: school.latitude, longitude: school.longitude})
            this.$refs.mapComponent.map.setZoom(zoom)
        },
        // Search Methods
        async autocompleteStreet() {
            this.orderedSchools = false
            this.predictions = await this.googleSearch.getPredictions(this.inputValue)
        },
        async autocompleteInput(placeId) {
            this.hideClearCross = false

            this.clearPredictions()

            const location = await this.googleSearch.getLocation(placeId)

            this.sortSchools(location)

            const centerSchools = getCenterOfSchools(this.schools)

            this.$refs.mapComponent.setMapCenter(centerSchools.coordinates)
            this.$refs.mapComponent.map.setZoom(centerSchools.zoom);
        },
        clearInput() {
            this.inputValue = ""
            this.hideClearCross = false

            this.clearPredictions();
            this.orderedSchools = false
        },
        clearPredictions() {
            return (this.predictions = []);
        },
        sortSchools(location) {
            this.schools = sortSchoolsByDistance(this.schools, location)
            this.orderedSchools = true;
        },
    },
    mounted(){
        this.trans = window?.trans;
    }
};
</script>